import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const Success = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  return (
    <div className="w-full md:flex justify-start items-start overflow-x-hidden font-jost bg-gray-50 min-h-screen">
      <div className="hidden lg:block">
        <Sidebar open={true} />
      </div>
      
      <div className="w-full lg:w-[75%] lg:ml-[25%] flex flex-col items-center justify-center min-h-screen p-4">
        <div className="bg-white rounded-3xl shadow-sm p-8 md:p-12 max-w-lg w-full text-center">
          {error ? (
            <>
              <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
              <h1 className="text-3xl font-extrabold text-gray-900 mb-4">Oops! Something went wrong</h1>
              <p className="text-gray-500 mb-8 leading-relaxed">
                We encountered an issue while processing your order confirmation. Please contact support if your payment was deducted.
              </p>
            </>
          ) : (
            <>
              <div className="w-24 h-24 bg-[#E1F7EB] rounded-full flex items-center justify-center mx-auto mb-6 relative">
                <div className="absolute inset-0 bg-[#E1F7EB] rounded-full animate-ping opacity-75"></div>
                <svg className="w-12 h-12 text-[#20AA5F] relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h1 className="text-3xl font-extrabold text-gray-900 mb-4">Payment Successful!</h1>
              <p className="text-gray-500 mb-8 leading-relaxed font-medium">
                Thank you for your purchase. Your order has been successfully placed and is now being processed. We've sent a confirmation to your email!
              </p>
            </>
          )}

          <div className="flex flex-col gap-3">
            <Link to="/order">
              <button className="w-full bg-gray-900 hover:bg-black text-white font-semibold py-4 rounded-full transition-all shadow-lg hover:shadow-xl hover:-translate-y-1">
                View My Orders
              </button>
            </Link>
            <Link to="/">
              <button className="w-full bg-[#fff1f5] hover:bg-[#ffe1ea] text-[#FFB7CF] font-semibold py-4 rounded-full transition-colors">
                Continue Shopping
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
